import {summaryHomeAPI} from 'entities/monitor';
import {getPollingInterval} from 'shared/api/pollingHelper';

export interface IHomeState {
    isLanding: boolean,
}

export const useHomeState = (): IHomeState => {
    const {data, isLoading, isError} = summaryHomeAPI.useGetSummaryHomeQuery(undefined, {
        pollingInterval: getPollingInterval(),
    });

    return {
        isLanding: !isLoading && !isError && data?.has_monitors === false,
    };
};

export default useHomeState;
